import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cnpj' })
export class CnpjPipe implements PipeTransform {
   transform(value: string | null | undefined): string | undefined  {
     if (!value) { return undefined; }
    
    const cleanValue = String(value).trim();

     if (/^\d{14}$/.test(cleanValue)) {
      return cleanValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    if (/^[a-zA-Z0-9]{14}$/.test(cleanValue)) {
      return cleanValue.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
    }
    return undefined;
  }
}
